<template>
  <b-container id="app" class="lizard-wrapper" fluid>
    <div class="lizard-content">
      <router-view />
    </div>
    <footer class="lizard-footer">
      <div class="footer-version">
        <span class="version-badge">Portal v{{ appVersion }}</span>
      </div>
      <div class="footer-brand">
        &copy; 2026 <span>Candesic</span>
      </div>
    </footer>
  </b-container>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    appName() {
      return this?.$store?.getters?.appName ?? 'default'
    },
    appVersion() {
      return this?.$store?.getters?.appVersion ?? '0.0.0'
    }
  }
}
</script>

<style>
@font-face {
  font-family: 'CANDESIC-FONT';
  src: url('assets/fonts/myriad-pro/MYRIADPRO-REGULAR.OTF') format('opentype');
}
@font-face {
  font-family: 'CANDESIC-FONT-UNLICENCED';
  src: url('assets/fonts/cocomat/Cocomat Light-trial.ttf')
}
html,
body {
  height: 100% !important;
  margin: 0;
  padding: 0;
  font-family: Arial, sans-serif !important;
  /* font-family: 'CANDESIC-FONT', Arial, sans-serif !important; */
}
body {
  background: rgba(100, 100, 100, 0.55) url('assets/bg-1.jpg') no-repeat center
    center fixed !important;
  -webkit-background-size: cover !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
  background-blend-mode: darken;
  display: flex;
  flex-direction: column;
}
.lizard-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  margin: 0 !important;
  padding: 0 !important;
}
.lizard-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.lizard-footer {
  left: 0;
  bottom: 0;
  width: 100%;
  background: linear-gradient(135deg, rgba(0, 45, 84, 0.85) 0%, rgba(0, 96, 163, 0.85) 100%) !important;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  color: #ffffff !important;
  padding: 0.75rem 2rem !important;
  font-size: 0.85rem !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0.02em !important;
  margin-top: auto !important;
  border-top: none !important;
  box-shadow: 0 -4px 20px rgba(0, 84, 170, 0.15);
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  height: 56px !important;
}

.lizard-footer .footer-brand span {
  color: #ffffff;
  font-weight: 800;
  letter-spacing: 0.05em;
}

.lizard-footer .version-badge {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.25) !important;
  padding: 3px 10px !important;
  border-radius: 9999px !important;
  font-size: 0.75rem !important;
  font-weight: 600 !important;
  color: #ffffff !important;
  letter-spacing: 0.05em;
}
.tab-content {
  min-height: calc(100vh - 240px) !important;
}
.tab-pane {
  min-height: inherit;
}
.tab-pane > .container,
.tab-pane > .container-fluid {
  min-height: inherit;
}
.bg-white {
  background-color: #f5f4ef !important;
}
</style>
